import styled from 'styled-components';
import { COLORS, FONTS } from '@ertelecom/ui-react/assets/js/constants';

export const Wrapper = styled.div`
    display: block;
    line-height: 1.33;
`;

export const Title = styled.h2`
    ${FONTS.H3};
    margin-bottom: 10px;
    color: ${COLORS.black};
    @media(max-width: 640px) {
        ${FONTS.H4};
    }
`;

export const Text = styled.div`
    ${FONTS.S};
    color: ${COLORS.darkGrey};
`;
